/* global cacheControlVersion */
const closedSiteMessageIdsCookieName = 'closed_site_message_ids';
const closedSiteMessageIdsCookie = adcReadCookie(closedSiteMessageIdsCookieName) || '[]';
const closedSiteMessageIds = JSON.parse(closedSiteMessageIdsCookie);

const renderSiteMessages = (messages) => {
  messages.forEach(message => {
    if (closedSiteMessageIds.includes(message.id)) {
      return;
    }

    const messageElem = $(`<div class="adc_page_message ${message.type}" data-id="${message.id}">
          <p>${message.description}</p>
          <div class="close_btn"><i class="fa fa-times"></i></div>
        </div>`);

    $('#site_messages_container').append(messageElem);

    messageElem.find('.close_btn').on('click', function () {
      const messageId = $(this).parent().data('id');
      closedSiteMessageIds.push(messageId);
      // set cookie to expire in one day
      createCookie(closedSiteMessageIdsCookieName, JSON.stringify(closedSiteMessageIds), 1 * 24 * 60); // 1 day in minutes
      $(this).parent().slideUp(500, function () {
        $(this).remove();
      });
    });
  });

  $('.adc_page_message').slideDown(500);
};

$.ajax({
  type: 'GET',
  cache: true,
  url: loadUrl('api', 'site-messages' + '?v=' + cacheControlVersion),
  success: function (response) {
    const messages = response.data;
    if (messages.length <= 0) {
      return;
    }
    renderSiteMessages(messages);
  }
});
